<!-- 
お知らせ検索の登録日入力欄
-->

<template>
  <v-menu v-model="showDatePicker" z-index="0" :close-on-click="false" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        style="font-size: 20px"
        class="ma-2"
        width="200"
        height="50"
        v-bind="attrs"
        v-on="on"
        outlined
        @click="showDatePicker = !showDatePicker"
        :disabled="false"
        >{{ localizedDate }}
      </v-btn>
    </template>
    <v-date-picker
      locale="jp"
      v-model="date"
      elevation="12"
      :width="400"
      :day-format="pickupDate"
      :min="dateRange.min"
      :max="dateRange.max"
      :picker-date.sync="pickerDate"
      :active-picker.sync="activePicker"
    >
    <v-spacer></v-spacer>
      <v-btn text color="primary" @click="datePickerCancel">キャンセル</v-btn>
      <v-btn text color="primary" @click="datePickerApply">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  props: ["searchStartDate", "searchEndDate", "dateSub", "events", "minDate", "defaultFocus"],
  computed: {
    /**
     * 検索対象日を表示日時に変換して返す
     */
    localizedDate() {
      return new DateWrapper(this.registrationDate).format.localizedDate;
    },
  },
  data() {
    const now = new DateWrapper(Date.now()).format;
    return {
      showDatePicker: false,
      date: this.defaultFocus ? this.defaultFocus : now.systemDate,
      beforeFocus: this.defaultFocus ? this.defaultFocus : now.systemDate,
      registrationDate: this.workDate,
      pickerDate: null,
      activePicker: null,
      dateRange: {
        min: this.minDate,
        max: now.systemDate,
      },
    };
  },
  watch: {
    /**
     * カレンダーの表示月が変更されたのであれば、月間イベントを再取得する
     */
    pickerDate(newval, oldval) {
      const newDate = new DateWrapper(newval);
      const oldDate = new DateWrapper(oldval);
      let updated = false;
      if (newDate.isValid && oldDate.isValid) {
        if (newDate.format.systemDate != oldDate.format.systemDate) {
          updated = true;
        }
      } else if (newDate.isValid) {
        updated = true;
      }
      if (updated) {
        this.$emit("on-update-calendar-month", newDate);
      }
    },
    searchStartDate() {
      console.log("searchStartDate = " + this.searchStartDate);
      this.updateRegistrationStartDate(this.searchStartDate);
    },
    searchEndDate() {
      console.log("searchEndDate = " + this.searchEndDate);
      this.dateRange.max = this.searchEndDate;
    },
  },
  methods: {
    /**
     * 登録対象日を更新する
     */
    updateRegistrationStartDate(newRegistrationDate) {
      if (this.registrationDate != newRegistrationDate) {
        this.registrationDate = newRegistrationDate;
        this.beforeFocus = newRegistrationDate;
        this.date = newRegistrationDate;
        this.$emit("on-update-registration-start-date", this.registrationDate);
      }
    },
    /**
     * カレンダーピッカーの選択をキャンセルして閉じる
     */
     datePickerCancel() {
      // カレンダーピッカーのカーソルを変更前に戻す
      this.date = this.beforeFocus;
      // カレンダーピッカーを開いた時の表示月を変更前に戻す
      this.pickerDate = this.beforeFocus;
      // カレンダーピッカーを閉じる
      this.showDatePicker = false;
    },
    /**
     * カレンダーピッカーの選択日時を検索対象日に反映する
     */
    datePickerApply() {
      this.updateRegistrationStartDate(this.date);
      // カレンダーピッカーを閉じる
      this.showDatePicker = false;
    },
    /**
     * 日時文字列をオフセット日だけずらして返却する
     */
    parseDateInfo(dateString, offsetDays) {
      const currentDate = new DateWrapper(dateString).appendDay(offsetDays);
      const currentMonth = currentDate.format.build(
        (d) => `${d.date.y}-${d.date.m}`
      );
      return {
        month: currentMonth,
        date: currentDate.format.systemDate,
      };
    },
    /**
     * 対象日から日を取得する
     */
    pickupDate(date_string) {
      return new DateWrapper(date_string).format.build((d) => `${d.date.d}`);
    },
  },
};
</script>

<!--DatePickerのスタイルを継承して書き換え、2つ目で改行するようにする -->
<style>
.v-date-picker-table th {
  background-color: #ffffff !important;
}

.v-date-picker-table__events {
  max-width: 20px !important;
  left: 6px !important;
  top: 24px !important;
}

.v-date-picker-table--date div {
  float: left !important;
  margin-bottom: 1px !important;
  margin-left: 1px !important;
  margin-right: 0px !important;
  margin-top: 0px !important;
}

.no-background-color {
  background-color: transparent !important;
  border-color: transparent !important;
}
</style>
